import React, { useEffect , useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from '../components/Loader/Loader';
import { selectUser } from '../slice/authSlice';
import { isLoading } from '../slice/commonSlice';

const UserLayout = ({ children }) => {

  let navigate = useNavigate();
  const loading = useSelector(isLoading);
  const user = useSelector(selectUser);
  useEffect(() => {
    if (!user?.token || !user?.email) {
      navigate('/');
    }

  });
  return (
    <>
      {loading ? <Loader /> : null}
      {
        (user?.token && user?.userType === 'user') ?
          <>{children}</>
          : null
      }

    </>
  );
};

export default UserLayout;
